import React from "react";

const MailUnsubscribeIcon = ({
  className,
  ...rest
}: {
  className?: string;
}) => {
  return (
    <svg
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className ? className : "w-[18px] h-[18px]"}
      {...rest}
    >
      <path
        d="M7.09875 11.1637C6.46875 10.4462 5.5325 10 4.5 10C2.56625 10 1 11.5662 1 13.5C1 14.1562 1.18375 14.7775 1.5075 15.3025C1.6825 15.6 1.91 15.8712 2.1725 16.0987C2.785 16.6587 3.59875 17 4.5 17C5.7775 17 6.88875 16.3175 7.4925 15.3025C7.81625 14.7775 8 14.1562 8 13.5C8 12.6075 7.65875 11.785 7.09875 11.1637ZM5.9 14.8825C5.76875 15.0138 5.6025 15.075 5.43625 15.075C5.27 15.075 5.10375 15.0138 4.9725 14.8825L4.50875 14.4187L4.0275 14.9C3.89625 15.0313 3.73 15.0925 3.56375 15.0925C3.3975 15.0925 3.23125 15.0313 3.1 14.9C2.84625 14.6463 2.84625 14.2263 3.1 13.9725L3.58125 13.4912L3.1175 13.0275C2.86375 12.7737 2.86375 12.3537 3.1175 12.1C3.37125 11.8462 3.79125 11.8462 4.045 12.1L4.50875 12.5638L4.94625 12.1263C5.2 11.8725 5.62 11.8725 5.87375 12.1263C6.1275 12.38 6.1275 12.8 5.87375 13.0537L5.43625 13.4912L5.9 13.955C6.15375 14.2088 6.15375 14.62 5.9 14.8825Z"
        fill="currentColor"
      />
      <path
        d="M12.75 2.25H5.25C3 2.25 1.5 3.375 1.5 6V8.355C1.5 8.9025 2.0625 9.2475 2.565 9.03C3.39 8.67 4.3275 8.535 5.31 8.6925C7.275 9.015 8.88 10.5675 9.2775 12.5175C9.39 13.0875 9.405 13.6425 9.33 14.175C9.27 14.6175 9.63 15.0075 10.0725 15.0075H12.75C15 15.0075 16.5 13.8825 16.5 11.2575V6C16.5 3.375 15 2.25 12.75 2.25ZM13.1025 6.4425L10.755 8.3175C10.26 8.715 9.63 8.91 9 8.91C8.37 8.91 7.7325 8.715 7.245 8.3175L4.8975 6.4425C4.6575 6.2475 4.62 5.8875 4.8075 5.6475C5.0025 5.4075 5.355 5.3625 5.595 5.5575L7.9425 7.4325C8.5125 7.89 9.48 7.89 10.05 7.4325L12.3975 5.5575C12.6375 5.3625 12.9975 5.4 13.185 5.6475C13.38 5.8875 13.3425 6.2475 13.1025 6.4425Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default MailUnsubscribeIcon;
